import { axiosInstance } from "../../config/axios";

const handlerEnabled = true;
export const getAllOrders = async (row, page = 1, filters = {}) => {
  try {
    const res = await axiosInstance.get("order/", {
      params: { page_size: row, page: page, ...filters },
      handlerEnabled,
    });

    const { data } = res;
    data["success"] = true;
    return res.data;
  } catch (e) {
    const data = {
      success: false,
    };
    return data;
  }
};

export const getOrderDetails = async (id) => {
  try {
    const res = await axiosInstance.get(`order/${id}`);

    const { data } = res;
    data["success"] = true;
    return res.data;
  } catch (e) {
    const data = {
      success: false,
    };
    return data;
  }
};

export const getAiOrders = async (page = 1, filters = {}) => {
  try {
    const params = new URLSearchParams({
      page,
      ...filters,
    });
    console.log("params...", filters);
    const res = await axiosInstance.get(`ai-orders/?${params}`);

    return {
      success: true,
      data: res.data,
    };
  } catch (e) {
    return {
      success: false,
      data: [],
    };
  }
};
export const getOffers = (page = 1, pageSize = 10, search = "") => {
  return axiosInstance.get("/offers/", {
    params: {
      page,
      page_size: pageSize,
      search,
    },
  });
};
export const getOfferDetail = (id) => {
  return axiosInstance.get(`/offers/${id}/`);
};
export const getVouchers = (
  page = 1,
  pageSize = 10,
  search = "",
  offer = "",
) => {
  return axiosInstance.get("/vouchers/", {
    params: {
      page,
      page_size: pageSize,
      search,
      offer,
    },
  });
};
export const checkVoucherCode = (code, id = null) => {
  return axiosInstance.get("/voucher/check-code/", {
    params: {
      code,
      id,
    },
  });
};
export const getVoucherDetail = (id) => {
  return axiosInstance.get(`/vouchers/${id}/`);
};

export const createOffer = (data) => {
  return axiosInstance.post("/offers/", data);
};
export const updateOffer = async (id, payload) => {
  return axiosInstance.patch(`offers/${id}/`, payload);
};
export const updateVoucher = (id, payload) => {
  return axiosInstance.patch(`vouchers/${id}/`, payload);
};

export const getOfferMetadata = () => {
  return axiosInstance.get("/offer-metadata/");
};
export const getVoucherMetadata = async () => {
  return axiosInstance.get("voucher-metadata/");
};

export const createVoucher = async (payload) => {
  return axiosInstance.post("vouchers/create/", payload);
};
